export default function ContactSection() {
  return (
    <section id="contact" className="py-24 md:py-32" style={{ background: "#f5f4f2" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-14">
          <span className="text-xs font-semibold tracking-widest uppercase text-gray-400">
            Get in Touch
          </span>
          <h2 className="mt-3 text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
            Contact FELIN SRL
          </h2>
          <p className="mt-4 text-gray-500 text-base max-w-lg leading-relaxed">
            Reach out to our team with any questions about our iOS applications, partnerships,
            or business inquiries.
          </p>
        </div>

        {/* Main contact card */}
        <div className="bg-white rounded-3xl overflow-hidden grid grid-cols-1 lg:grid-cols-2">
          {/* Left: image + brand */}
          <div className="relative min-h-64 lg:min-h-full">
            <img
              src="https://public.readdy.ai/ai/img_res/562cbc9e78215b6564b4f43ad9c9858f.jpg"
              alt="FELIN SRL Office"
              className="w-full h-full object-cover object-top absolute inset-0"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <img
                src="https://public.readdy.ai/ai/img_res/8b0a0fe9-2c54-4ed5-8ae9-c59cc596a592.png"
                alt="FELIN SRL Logo"
                className="h-10 w-auto object-contain mb-3"
              />
              <p className="text-white font-bold text-xl">FELIN SRL</p>
              <p className="text-white/60 text-sm mt-1">iOS Application Development</p>
            </div>
          </div>

          {/* Right: contact info */}
          <div className="p-8 md:p-12 flex flex-col gap-8">
            {/* Address block */}
            <div>
              <h3 className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-4">
                Office Address
              </h3>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-2-line text-gray-600 text-sm" />
                  </div>
                  <div>
                    <p className="text-gray-900 font-medium text-sm">STR. ROMANA-BOLDESCU NR. 118</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0">
                    <i className="ri-building-2-line text-gray-600 text-sm" />
                  </div>
                  <div className="space-y-0.5">
                    <p className="text-gray-700 text-sm">
                      <span className="text-gray-400 text-xs mr-1">City</span>
                      <strong>Ploiesti</strong>
                    </p>
                    <p className="text-gray-700 text-sm">
                      <span className="text-gray-400 text-xs mr-1">Zip</span>
                      <strong>100001</strong>
                    </p>
                    <p className="text-gray-700 text-sm">
                      <span className="text-gray-400 text-xs mr-1">Country</span>
                      <strong>Romania</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-100" />

            {/* Contact details */}
            <div>
              <h3 className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-4">
                Direct Contact
              </h3>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line text-gray-600 text-sm" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">Email</p>
                    <p className="text-gray-900 font-medium text-sm">contact@felinsrl.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0">
                    <i className="ri-phone-line text-gray-600 text-sm" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">Number</p>
                    <p className="text-gray-900 font-medium text-sm">+1 6814914585</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-100" />

            {/* Business hours */}
            <div>
              <h3 className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-4">
                Business Hours
              </h3>
              <div className="space-y-1.5 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-500">Monday – Friday</span>
                  <span className="text-gray-900 font-medium">09:00 – 18:00 EET</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Saturday</span>
                  <span className="text-gray-900 font-medium">10:00 – 14:00 EET</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Sunday</span>
                  <span className="text-gray-400">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer bar */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 px-2">
          <p className="text-gray-400 text-xs">
            &copy; {new Date().getFullYear()} FELIN SRL. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-gray-400">
            <span>Privacy Policy</span>
            <span className="text-gray-300">|</span>
            <span>Terms of Service</span>
            <span className="text-gray-300">|</span>
            <span>Cookie Policy</span>
          </div>
        </div>
      </div>
    </section>
  );
}
